import { render, staticRenderFns } from "./UploadXuFei.vue?vue&type=template&id=017f2591&scoped=true&"
import script from "./UploadXuFei.vue?vue&type=script&lang=js&"
export * from "./UploadXuFei.vue?vue&type=script&lang=js&"
import style0 from "./UploadXuFei.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UploadXuFei.vue?vue&type=style&index=1&id=017f2591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f2591",
  null
  
)

export default component.exports